module.exports = __webpack_public_path__ + "img/db.e9efedaa.webp";